'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const TacticsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M3.19995 5.3L5.79995 7.9M5.79995 7.9L8.39995 10.5M5.79995 7.9L8.39995 5.3M5.79995 7.9L3.19995 10.5M15.6 15.6L18.2 18.2M18.2 18.2L20.7999 20.8M18.2 18.2L20.7999 15.6M18.2 18.2L15.6 20.8M13.7 7.5L16.2 3.8L19.9 6.3M16.1 3.8L16.4 5.3C18.3 10.2 12.9 12.9 11.4 14M8.89995 17.7C8.89995 19.1 7.69995 20.3 6.29995 20.3C4.89995 20.3 3.69995 19.1 3.69995 17.7C3.69995 16.3 4.89995 15.1 6.29995 15.1C7.79995 15.1 8.89995 16.2 8.89995 17.7Z",
        stroke: "currentColor"
      }
    )
  }
);
const VpTacticsIcon = forwardRef(TacticsIcon);

export { VpTacticsIcon as default };
